import { Camera, Image as ImageIcon, Upload, Check } from "lucide-react";

export default function UploadScreen() {
  return (
    <div className="flex h-full flex-col bg-neutral-950 text-white">
      <div className="px-5 pt-10 pb-4">
        <p className="text-[10px] uppercase tracking-[0.2em] text-neutral-400">Contribute</p>
        <p className="mt-1 font-['Playfair_Display'] text-2xl leading-tight">
          Pilih foto <br />atau video
        </p>
      </div>

      <div className="mx-4 space-y-2">
        <ActionRow icon={<Camera className="h-4 w-4" strokeWidth={1.5} />} label="Ambil Foto / Video" />
        <ActionRow icon={<ImageIcon className="h-4 w-4" strokeWidth={1.5} />} label="Pilih dari Galeri" />
      </div>

      <div className="mx-4 mt-5 rounded-xl bg-white/5 p-3">
        <div className="flex items-center justify-between">
          <span className="text-[10px] uppercase tracking-wider text-neutral-400">Uploading</span>
          <span className="text-[10px] text-neutral-300">4 / 6</span>
        </div>
        <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-white/10">
          <div className="h-full w-2/3 bg-white" />
        </div>
        <div className="mt-3 space-y-1.5">
          {[
            { name: "IMG_2043.jpg", done: true },
            { name: "IMG_2044.jpg", done: true },
            { name: "VID_0031.mov", done: false },
          ].map((f) => (
            <div key={f.name} className="flex items-center justify-between text-[10px]">
              <span className="text-neutral-300">{f.name}</span>
              {f.done ? (
                <Check className="h-3 w-3 text-emerald-400" strokeWidth={2} />
              ) : (
                <span className="text-neutral-500">62%</span>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="mt-auto p-4">
        <button className="flex w-full items-center justify-center gap-2 rounded-full bg-white py-3 text-xs font-medium text-neutral-900">
          <Upload className="h-3.5 w-3.5" strokeWidth={2} />
          Upload
        </button>
      </div>
    </div>
  );
}

function ActionRow({ icon, label }) {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.03] px-3 py-3">
      <div className="grid h-8 w-8 place-items-center rounded-lg bg-white/10">{icon}</div>
      <span className="text-xs text-neutral-200">{label}</span>
    </div>
  );
}
